import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const Share: React.FC<SvgProps> = ({ pathFill = '#697277', ...props }) => {
	return (
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				d='M9 7.50014H6C3.93125 7.50014 2.1875 8.89702 1.6625 10.797C1.55938 10.4095 1.5 9.97827 1.5 9.50014C1.5 7.29077 3.29063 5.50014 5.5 5.50014H9H9.75C10.1656 5.50014 10.5 5.16577 10.5 4.75014V4.00014V3.12202L14.2531 6.50014L10.5 9.87827V9.00014V8.25014C10.5 7.83452 10.1656 7.50014 9.75 7.50014H9ZM9 9.00014V10.5001V11.0001C9 11.3939 9.23125 11.7533 9.59375 11.9126C9.95625 12.072 10.375 12.0064 10.6687 11.7439L15.6687 7.24389C15.8781 7.05327 16 6.78452 16 6.50014C16 6.21577 15.8812 5.94702 15.6687 5.75639L10.6687 1.25639C10.375 0.990766 9.95312 0.925141 9.59375 1.08764C9.23438 1.25014 9 1.60639 9 2.00014V2.50014V4.00014H7.5H5.5C2.4625 4.00014 0 6.46264 0 9.50014C0 11.9376 1.20625 13.4439 2.14687 14.2533C2.275 14.3626 2.4 14.4595 2.5125 14.5439C2.6125 14.6189 2.70625 14.6814 2.79063 14.7376C2.93125 14.8314 3.05 14.897 3.12812 14.9408C3.20625 14.9845 3.29375 15.0001 3.38125 15.0001C3.72187 15.0001 3.99688 14.722 3.99688 14.3845C3.99688 14.172 3.88437 13.972 3.7375 13.8189C3.72187 13.8033 3.70937 13.7908 3.69375 13.7751C3.61875 13.7033 3.53437 13.6158 3.45312 13.5064C3.4 13.4345 3.34687 13.3501 3.29688 13.2595C3.13125 12.9564 3 12.5439 3 12.0033C3 10.347 4.34375 9.00327 6 9.00327H7.5H9V9.00014Z'
				fill={pathFill}
			/>
		</svg>
	);
};
